export default {
    about_doctor: "Shifokor haqida",
    account_manager: "Akkaunt menejeri",
    activated: "Faollashtirilgan",
    additional_info: "Qo'shimcha ma'lumot",
    administrator: "Administrator",
    administrators: "Administratorlar",
    amount_of_doctors: "Shifokorlar soni",
    are_you_sure_you_want_to_delete_field: "Siz yo‘nalishni o‘chirishga ishonchingiz komilmi",
    assistants: "Yordamchilar",
    backup_code: "Zaxira kodi",
    block: "Bloklash",
    block_noun: "Blok",
    browse_computer: "Fayllardan tanlash",
    by_cabinets: "Ofis tomonidan",
    by_days: "Kunlar bo‘yicha",
    by_days_of_week: "Hafta kunlari bo‘yicha",
    by_even_days: "Juft kunlar bo‘yicha",
    by_odd_days: "Toq kunlar bo‘yicha",
    cabinet: "Kabinet",
    cabinets: "Shkaflar",
    chair: "O‘rindiq",
    chairs: "O‘rindiqlar",
    clinic_access_request: "Klinikaga kirish so‘rovi",
    config: "Konfigurasiya",
    confirm_password: "Parolni qaytarish",
    curator: "Kurator",
    curators: "Kuratorlar",
    dentist_plus_tech_support_requests_access_to_your_clinic: "Dentist+ Texnik qo‘llab-quvvat so‘rovlari klinikangizga kir",
    doctor_position: "Shifokorning pozitsiyasi",
    doctor_specialty: "Doktorlik mutaxassisligi",
    enter_backup_code_note: "Ikki faktorli autentifikatsiyani faollashtirganingizda olingan zahira kodlaridan birini kiriting. Esda tutingki, har bir zahiraviy kod faqat bir marta ishlatilishi mumkin",
    enter_code_from_authorization_app: "Telefoningizdagi ikki faktorli autentifikatsiya ilovasidan kodni kiriting",
    field: "Yo'nalish",
    fields: "Yo'nalishlar",
    functionality: "Funksional",
    login_and_password: "Login va parol",
    manual_pay_system: "Qo‘llab-quvvatlash tizimi",
    not_worked: "Ishlanmagan",
    partner: "Sherik",
    password_does_not_match_confirmation: "Parol tasdiqlanganga mos kelmaydi",
    password_requirement_min_length: "Kamida {min} ta belgi",
    password_requirement_mixed_case: "Lotin katta va kichik harflari",
    password_requirement_number: "Raqam majburiy",
    password_requirement_symbol: "Maxsus belgi majburiy",
    percent: "Foiz",
    period_from: "dan boshlab davr",
    period_to: "gacha bo‘lgan davr",
    phone2: "2-telefon",
    profession: "Mutaxassislik",
    rate: "Maosh",
    rate_per_day: "Kunlik tarif",
    rate_per_hour: "Bir soatlik tarif",
    rate_per_month: "Oylik stavka",
    reserve_codes: "Zaxira kodlari",
    roles: "Rollar",
    sale_good_percent: "Tovarlarni sotishdan foiz",
    schedule_conflicts_found: "Joriy yozuvlar bilan jadvalda ziddiyatlar topildi",
    seller: "Savdogar",
    staff: "Xodimlar",
    take_photo: "Rasmga olish",
    technics: "Texniklar",
    turn_on: "Yoqish; ishga tushirish",
    turned_off: "O'chirilgan",
    two_factor_authorization: "Ikki faktorli autentifikatsiya",
    two_factor_authorization_setup_successfully: "Ikki faktorli autentifikatsiya muvaffaqiyatli faollashtirildi",
    twofactor_setup_instructions: "<ul><li>Authenticator ilovasini (masalan, Google Authenticator, Microsoft Authenticator, Yandex.Key) App Store yoki Google Play'dan yuklab oling.</li><li>Telefoningizdagi ilovada \"Kod qo'shish\"/'+' tugmasini bosing va kompyuter ekranida ko'rsatilgan QR kodini skanerlang.</li><li>Quyidagi ilovaning 6 xonali kodini yaratish uchun tegishli maydonga QR kodini kiriting. bog'lashlar</li><li>Telefoningizni yo'qotib qo'ysangiz, tavsiya etilgan zahira kodlarini (6 xonali kod tekshirilgandan keyin paydo bo'ladi) xavfsiz joyda saqlang</li></ul>",
    use_app_code: "Standart koddan foydalaning",
    use_backup_code: "Zaxira kodidan foydalaning",
    user_data: "Foydalanuvchi ma’lumotlari",
    user_will_assigned_rights_selected_for_that_role: "Foydalanuvchi ushbu rol uchun tanlangan huquqlarni o‘zlashtiradi",
    weekend: "Dam olish kuni",
    without_warehouse_form_note: "Omborga bog‘lanmasdan, materiallar asosiy ombordan yoki o‘rindiqqa bog‘langan ombordan hisobdan chiqariladi",
    work_day: "Ish kuni",
    work_days: "Ish kunlari",
    work_schedule: "Ishlash jadvali",
    work_time: "Ish vaqti",
    worked: "Ishlangan"
}
